// Enums
import { EnvName } from '@enums/environment.enum';

// Packages
import packageInfo from '../../package.json';

export const environment = {
  production: false,
  version: packageInfo.version,
  appName: 'Navigator',
  envName: EnvName.DEV,
  defaultLanguage: 'en',
  apiBaseUrl: 'https://api.navigator.dev.s-marketing.ch',
  instanceUuid: '3b4a1a65-e57f-11f0-9c8d-0e6b4eaa0fa5',
  gaId: 'G-HXY2S02X37',
};
